import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import ShoppingBasketOutlinedIcon from '@mui/icons-material/ShoppingBasketOutlined';
import { useNavigate } from 'react-router-dom';
import { useBasket } from '../hooks/useBasket';

export default function BasketIcon() {
  const count = useBasket((s) => s.items.length);
  const navigate = useNavigate();

  return (
    <Tooltip title="Basket">
      <IconButton
        size="small"
        aria-label="Basket"
        onClick={() => void navigate('/basket')}
        color={count > 0 ? 'info' : 'default'}
      >
        <Badge badgeContent={count} color="primary">
          <ShoppingBasketOutlinedIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
